<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-12">
        <div class="card h-100 mt-3">
          <div class="card-header mb-0">
            <div class="row no-gutters">
              <div class="col-12 d-flex justify-content-between align-items-center">
                <h5>{{ $t("content.mbank") }}</h5>
                <div>
                  <material-button color="primary" class="float-lg-start float-sm-end mb-0" @click="addNewItems">
                    <i class="material-icons material-symbols-outlined">add</i>
                    {{ btnAddNew }}
                  </material-button>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div class="row">
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>
                        {{
                          $t("content.mbankname") + "(" + $t("content.th") + ")"
                        }}
                      </th>
                      <th>
                        {{
                          $t("content.mbankname") + "(" + $t("content.en") + ")"
                        }}
                      </th>
                      <th>
                        {{
                          $t("content.bankcode")
                        }}
                      </th>
                      <th width="250px">{{ $t("content.mlogo") }}</th>
                      <th v-if="addNew || rowEdit"></th>

                      <th width="100px">{{ $t("content.mcolor") }}</th>
                      <th>{{ $t("content.act") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="group-id-ticket">
                      <td class="text-sm font-weight-normal">
                        <div class="group-tickect">
                          <h6 class="mb-0">
                            <b>{{ btnSearch }}</b>
                          </h6>
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="nameTh" type="text" class="mb-0" :label="lbBankTH" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="nameEn" type="text" class="mb-0" :label="lbBankEN" />
                      </td>
                      <td class="text-sm font-weight-normal"></td>
                      <td class="text-sm font-weight-normal"></td>
                      <td v-if="addNew || rowEdit" class="text-sm font-weight-normal"> </td>
                      <td class="text-sm font-weight-normal"></td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSearch" @click="loadDataApi">
                          <i class="material-icons material-symbols-outlined">search</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="addNew">
                      <td class="text-sm font-weight-normal">#</td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="newnameTh" type="text" class="mb-0" value="" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="newnameEn" type="text" class="mb-0" value="" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="newCode" type="text" class="mb-0" value="" maxlength="3"
                          @input="onlyDigits" />
                        <!-- <InputNumber v-model="newCode" autocomplete="off" @focus="$event.target.select()"
                          maxlength="3" /> -->
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="input-group custom-file-button">
                          <label for="upload" class="input-group-text mb-0">{{
                            $t("buttons.file")
                          }}</label>
                          <input id="upload" type="file" accept="image/*" class="form-control mb-0" @change="addFile" />
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <div class="bank-logo">
                          <!-- <img :src="logo" alt="" /> -->
                          <img :src="preview_a" alt="" max-width="200" max-height="200" aspect-ratio="1" />
                        </div>
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-input v-model="newcolor" type="color" />
                      </td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSave" :disabled="newnameEn.trim() === '' ||
                            newnameTh.trim() === '' ||
                            newcolor === '' || thumb === null || newCode === ''
                            " @click="saveNewItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnClose"
                          @click="cancelSaveNewItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-for="(row, index) in list" :key="index">
                      <td class="text-sm font-weight-normal">
                        {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <material-input v-model="newnameTh" type="text" class="mb-0" />
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <material-input v-model="newnameEn" type="text" class="mb-0" />
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <material-input v-model="newCode" type="text" class="mb-0" value="" maxlength="3"
                          @input="onlyDigits" />
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <div class="input-group custom-file-button">
                          <label for="uploadEdit" class="input-group-text mb-0">{{ $t("buttons.file")
                          }}</label>
                          <input id="uploadEdit" type="file" class="form-control mb-0" accept="image/*" title="abc"
                            @change="addFile" />
                        </div>
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <div class="bank-logo">
                          <!-- <img :src="logo" alt="" /> -->
                          <img :src="preview_e" alt="" max-width="200" max-height="200" aspect-ratio="1" />
                        </div>
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <material-input v-model="newcolor" type="color" class="mb-0" />
                      </td>
                      <td v-if="row.uid === uid" class="text-sm font-weight-normal">
                        <material-button color="primary" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnSave" :disabled="newnameEn.trim() === '' ||
                            newnameTh.trim() === '' ||
                            newcolor === '' || thumb === null || newCode === ''" @click="saveEditRowItems">
                          <i class="material-icons material-symbols-outlined">save</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnClose"
                          @click="cancelEditRowItems">
                          <i class="material-icons material-symbols-outlined">close</i>
                        </material-button>
                      </td>
                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        {{ row.nameTh }}
                      </td>

                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        {{ row.nameEn }}
                      </td>
                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        {{ row.code }}
                      </td>
                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        <div class="bank-logo">
                          <!-- <img :src="logo" alt="" /> -->
                          <img :src="row.thumb" alt="" max-width="200" max-height="200" aspect-ratio="1" />
                        </div>
                      </td>
                      <td v-if="row.uid !== uid && (addNew || rowEdit)" class="text-sm font-weight-normal">
                      </td>
                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        <material-input v-model="row.color" type="color" disabled />
                      </td>
                      <td v-if="row.uid !== uid" class="text-sm font-weight-normal">
                        <material-button color="info" variant="outline" class="rounded-circle" data-bs-toggle="tooltip"
                          data-bs-placement="top" :title="btnEdit" @click="editRowItems(row)">
                          <i class="material-icons material-symbols-outlined">edit</i>
                        </material-button>
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          data-bs-toggle="tooltip" data-bs-placement="top" :title="btnDel" @click="deleteRowItems(row)">
                          <i class="material-icons material-symbols-outlined">delete</i>
                        </material-button>
                      </td>
                    </tr>

                    <tr v-if="list.length === 0">
                      <td></td>
                      <td></td>
                      <td class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr v-if="!rowEdit && !addNew">
                      <td colspan="7" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                    <tr v-if="rowEdit || addNew">
                      <td colspan="8" style="text-align: right">Total Rows : {{ totalRows_s }}</td>
                    </tr>
                  </tfoot>
                </table>
                <ul v-show="list.length > 0" class="pagination justify-content-end">
                  <div class="project-container">
                    <div class="example-one">
                      <vue-awesome-paginate v-model="currentPage" :total-items="totalRows" :items-per-page="perPage"
                        @click="onClickHandler" />
                    </div>
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import { reactive, inject, computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import InputNumber from 'primevue/inputnumber';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";

import logo from "@/assets/img/pawn/nvtx_logo.png";
import * as st from "@/config/setting.js";

import axios from "axios";
import noimg from "@/assets/img/noimg.png"
import moment from 'moment'


import { useGroupStore } from "@/stores/group";
import { useBankStore } from '@/stores/bank'
import { useDocumentStore } from '@/stores/document'


const { t } = useI18n();
const swal = inject("$swal");

const storeb = useBankStore()
const storedoc = useDocumentStore()
const storegr = useGroupStore()



const btnAddNew = computed(() => t("buttons.impo"));
const btnEdit = computed(() => t("buttons.edit"));
const btnSearch = computed(() => t("buttons.sear"));
const btnSave = computed(() => t("buttons.save"));
// const btnCancel = computed(() => t("buttons.canc"))
const btnDel = computed(() => t("buttons.remo"));
const btnClose = computed(() => t("buttons.clos"));

const lbBankTH = computed(
  () => t("content.mbankname") + " (" + t("content.th") + ")"
);
const lbBankEN = computed(
  () => t("content.mbankname") + "(" + t("content.en") + ")"
);
// const lbBankLogo = computed(() => t("content.mlogo"))

// const store = useStore();
const nameTh = ref("");
const nameEn = ref("");
const list = ref([]);
const newlogo = ref("");
const newnameTh = ref("");
const newnameEn = ref("");
const newCode = ref("");
const newcolor = ref("#000000");
const addNew = ref(false);
const rowEdit = ref(false);
const uid = ref("");
const version = ref("");

const thumb_name = ref("");
const thumb_id = ref("");
const thumb = ref(null);
const file_d = ref(null);
const urls = ref([]);
const file_L = ref([]);
const thumb_old = ref(null);
const file_old = ref(null);
const data_old = ref(null);
const preview_a = ref("");
const preview_e = ref("");
const oldlogo = ref("");
const lb = ref([]);
const regex = /data:.*base64,/
const mimeType = ref("");

const onClickHandler = async (page) => {
  // console.log('onClickHandler :' + page);
  await updatePagination()
};

const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(10);
const totalRows_s = ref();
const listgroup = ref([]);


const loadgroupListApi = async (val) => {
  listgroup.value = [];
  let data = "";
  data = {
    index: 0,
    size: 100,
    name: "",
  };
  const payload = data;
  // console.log("loadgroupListApi p : " + JSON.stringify(payload));
  const response = await storegr.groupListFetch(payload);
  // console.log("loadgroupListApi r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listgroup.value = response.data.data.list;
      }
    }
  }
}

loadgroupListApi();


const loadDataApi = async (val) => {
  clearItems();
  let data = "";
  lb.value = [];
  urls.value = []; // คงตัวแปรเคลียร์ค่าไว้ตามโครงสร้างเดิมของระบบคุณ

  if (currentPage.value !== 1) {
    if (list.value.length === 1 && val === 'del') {
      currentPage.value = currentPage.value - 1
    }
  }

  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    nameTh: nameTh.value,
    nameEn: nameEn.value,
  };
  
  const payload = data;
  const response = await storeb.bankListFetch(payload);

  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      lb.value = response.data.data.list;
      
      // ตั้งค่าเริ่มต้นให้กับรูปพรีวิวตาราง (Fallback เป็นภาพ noimg เผื่อไฟล์โหลดไม่ผ่าน)
      lb.value.forEach(function (obj) {
        obj.thumb = noimg;
        obj.file = null;
        obj.data = null;
      });

      // 🟢 1. ตรวจสอบว่าในข้อมูลรายการธนาคารรอบนี้ มีแถวที่มีโลโก้จริง (logoUid ไม่เป็น "0") หรือไม่
      const hasLogos = lb.value.some(item => item.logoUid && item.logoUid !== "0");
      
      if (hasLogos) {
        // 🟢 2. เรียกฟังก์ชันดึงไฟล์ตัวใหม่ที่เราปรับปรุงให้เป็น POST + Promise.all เรียบร้อยแล้ว
        await getFileLoco();
      }

      // แสดงผลข้อมูลตารางหลักตามปกติ
      list.value = lb.value;
      totalRows.value = response.data.data.ext.total;
      totalRows_s.value = formatNumberString(totalRows.value);
    }
  }
};

loadDataApi();

function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

async function onlyDigits() {

  if (newCode.value !== "") {
    if (newCode.value.match(/^[0-9]+$/)) {
      newCode.value = newCode.value.match(/^[0-9]+$/);

    } else {
      newCode.value = newCode.value.slice(0, -1);
    }
  } else {
    newCode.value = "";
  }
}

async function updatePagination() {
  list.value = []
  urls.value = []
  let data = "";
  lb.value = [];
  data = {
    index: currentPage.value - 1,
    size: perPage.value,
    nameTh: nameTh.value,
    nameEn: nameEn.value,
  };
  const payload = data;
  // const response = await store.dispatch("bankListFetch", payload);
  const response = await storeb.bankListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response));
  if (response) {
   if (response && response.status === 200) {
      if (response.data.rtnDesc === "success") {
        lb.value = response.data.data.list;
        
        // ตั้งค่าเริ่มต้นให้กับรูปพรีวิวตาราง (Fallback เป็นภาพ noimg เผื่อไฟล์โหลดไม่ผ่าน)
        lb.value.forEach(function (obj) {
          obj.thumb = noimg;
          obj.file = null;
          obj.data = null;
        });

        // 🟢 1. ตรวจสอบว่าในข้อมูลรายการธนาคารรอบนี้ มีแถวที่มีโลโก้จริง (logoUid ไม่เป็น "0") หรือไม่
        const hasLogos = lb.value.some(item => item.logoUid && item.logoUid !== "0");
        
        if (hasLogos) {
          // 🟢 2. เรียกฟังก์ชันดึงไฟล์ตัวใหม่ที่เราปรับปรุงให้เป็น POST + Promise.all เรียบร้อยแล้ว
          await getFileLoco();
        }

        // แสดงผลข้อมูลตารางหลักตามปกติ
        list.value = lb.value;
        totalRows.value = response.data.data.ext.total;
        totalRows_s.value = formatNumberString(totalRows.value);
      }
    }
  }
}


function filterFile(str, matchArr) {
  //  return matchArr.filter((c) => c.data.data.uid === str);
  return matchArr.filter((c) => c.logoUid === str);
}

async function addNewItems() {
  swal({
    title: "เพิ่มรายการ",
    text: "คุณต้องการเพิ่มรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      clearItems();
      addNew.value = true;
    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกรายการ", "", "error");
      addNew.value = false;
      clearItems();
    }
  });
}

async function saveNewItems() {
  swal({
    title: "ต้องการบันทึกรายการนี้",
    text: "คุณต้องการบันทึกรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.save"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      // swal("บันทึกสำเร็จ", "", "success");
      addNew.value = false;
      addbank();
    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกการบันทึก", "", "error");
      addNew.value = false;
      clearItems();
    }
  });
}

async function cancelSaveNewItems() {
  swal({
    title: "ยกเลิกบันทึกรายการนี้",
    text: "คุณต้องการยกเลิกบันทึกรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      addNew.value = false;
      clearItems();
    } else if (result.dismiss == "cancel") {
      addNew.value = true;
    }
  });
}

async function editRowItems(item) {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      clearItems();
      addNew.value = false;
      rowEdit.value = true;
      uid.value = item.uid;
      newnameTh.value = item.nameTh;
      newnameEn.value = item.nameEn;
      newlogo.value = item.logoUid;
      newcolor.value = item.color;
      version.value = item.version;
      thumb.value = item.thumb
      thumb_old.value = item.thumb
      file_old.value = item.file
      data_old.value = item.data
      preview_e.value = item.thumb
      oldlogo.value = item.logoUid
      newCode.value = item.code
      // console.log('item1 : ' + JSON.stringify(item));
      // console.log('version : ' + version.value)
      // console.log('thum e1 : ' + item.file)
      // console.log('thum e1 : ' + item.logoUid)

      // document.querySelector('#uploadEdit').files[0] = item.file;
      // const selectedFile = document.querySelector('#uploadEdit').files = item.file


    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกรายการ", "", "error");
      rowEdit.value = false;
      clearItems();
    }
  });
}

async function saveEditRowItems() {
  swal({
    title: "บันทึกแก้ไขรายการ",
    text: "คุณต้องการบันทึกแก้ไขรายการนี้ใช่ไหม",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.save"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      // swal("บันทึกสำเร็จ", "", "success");
      rowEdit.value = false;
      if (uid.value !== "" && version.value !== "") {
        updatebank();
      }
    } else if (result.dismiss == "cancel") {
      swal("ยกเลิกแก้ไข", "", "error");
      rowEdit.value = false;
      clearItems();
    }
  });
}

async function cancelEditRowItems() {
  swal({
    title: "ยกเลิกแก้ไขรายการ",
    text: "คุณต้องการยกเลิกแก้ไขรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      rowEdit.value = false;
      clearItems();
    } else if (result.dismiss == "cancel") {
      rowEdit.value = true;
    }
  });
}

async function deleteRowItems(item) {
  swal({
    title: "ลบรายการ",
    text: "คุณต้องการลบรายการนี้ใช่ไหม",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t("buttons.conf"),
    cancelButtonText: t("buttons.canc"),
  }).then((result) => {
    if (result.isConfirmed) {
      if (item.uid !== "") {
        deletebank(item.uid);
      }
    }
  });
}

async function addbank() {
  // 1. เช็คว่ามีการเลือกรูปภาพหรือไม่
  if (thumb.value !== null && thumb_name.value !== '') {
    // สั่งอัปโหลดไฟล์ และดักเอาผลลัพธ์ที่รีเทิร์นกลับมาตรวจสอบ
    const isUploadSuccess = await addfileApi();
    
    // ถ้าอัปโหลดรูปไม่สำเร็จ ให้หยุดการทำงานตรงนี้ทันที (ไม่ไปสร้างธนาคารต่อ)
    if (!isUploadSuccess) {
      return; 
    }
    thumb.value = null
    file_d.value = null 
  } else {
    // 💡 กรณีที่โปรเจกต์นี้ "บังคับ" ว่าต้องใส่รูปโลโก้เสมอ ให้เปิดแจ้งเตือนตรงนี้เพิ่มได้ครับ
    swal("กรุณาเลือกรูปโลโก้", "โปรดเลือกไฟล์โลโก้ธนาคารก่อนบันทึกข้อมูล", "warning");
    return;
  }

  // 2. ถ้าอัปโหลดรูปผ่านแล้ว (หรือไม่มีรูปให้ทำในกรณีที่รูปเป็น optional) ถึงจะมาทำส่วนนี้ต่อ
  let data = {
    nameTh: newnameTh.value,
    nameEn: newnameEn.value,
    logoUid: thumb_id.value,
    color: newcolor.value,
    code: String(newCode.value)
  };

  const payload = data;
  const response = await storeb.bankAddFetch(payload);
  
  if (response && response.status === 200) {
    if (response.data.rtnDesc === "success") {
      swal("บันทึกสำเร็จ", "", "success");
      loadDataApi('add');
    } else {
      swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
    }
  }
}

async function updatebank() {

  // เช็คเงื่อนไขว่าต้องมีการอัปโหลดรูปภาพใหม่เพิ่มเข้าไปหรือไม่
  if (newlogo.value === "" && thumb.value !== null && thumb_name.value !== '') {
    // สั่งอัปโหลดไฟล์ และดักผลลัพธ์ตัวแปร boolean ที่รีเทิร์นกลับมา
    const isUploadSuccess = await addfileApi();
    
    // 🟢 ถ้าอัปโหลดรูปไม่สำเร็จ ให้หยุดการทำงานตัดจบฟังก์ชันตรงนี้ทันที
    if (!isUploadSuccess) {
      return; 
    }
    
    // ถ้าอัปโหลดผ่าน ค่อยนำไอดีไฟล์ที่ได้มาใส่ในตัวแปร newlogo
    newlogo.value = thumb_id.value;
    thumb.value = null
    file_d.value = null 
  }

  // หลังจากผ่านด่านเช็คไฟล์แล้ว (หรือไม่มีการเปลี่ยนรูป) ถึงจะมาทำงานในส่วนของข้อมูลธนาคารต่อ
  let data = {
    uid: uid.value,
    nameTh: newnameTh.value,
    nameEn: newnameEn.value,
    logoUid: newlogo.value,
    color: newcolor.value,
    version: version.value,
    code: String(newCode.value)
  };

  const payload = data;
  const response = await storeb.bankUpdateFetch(payload);
  
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('update');
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function deletebank(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;
  // const response = await store.dispatch("bankDeleteFetch", payload);
  const response = await storeb.bankDeleteFetch(payload);
  // console.log('loadDataApi : '+JSON.stringify(response));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        loadDataApi('del');
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}
async function clearItems() {
  addNew.value = false;
  rowEdit.value = false;
  uid.value = "";
  version.value = "";
  newnameTh.value = "";
  newnameEn.value = "";
  newlogo.value = "";
  newcolor.value = "#000000";
  thumb.value = null
  thumb_old.value = null
  file_old.value = null
  data_old.value = null
  preview_e.value = ""
  preview_a.value = ""
  oldlogo.value = "";
  newCode.value = ""
}

async function uploadFetch(e) {
  file_d.value = null
  thumb.value = null
  thumb_name.value = ""
  newlogo.value = ""
  preview_a.value = ""
  preview_e.value = ""
  mimeType.value = ""
  thumb_id.value = ""

  if (e.target.files && e.target.files[0] !== undefined) {
    const originalFile = e.target.files[0]; // เปลียนชื่อตัวแปรภายในเพื่อไม่ให้สับสน
    const maxSize = 10 * 1024 * 1024; // 10 MB
   
    // 1. เช็คขนาดไฟล์
    if (originalFile.size > maxSize) {
      swal("ขนาดไฟล์เกิน 10 MB", "กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 10 MB", "warning");
      e.target.value = null;
      return;
    }

    // 2. ตั้งชื่อไฟล์และเช็ค MimeType
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    let baseName = 'banklogo_' + today // เก็บชื่อตั้งต้นไว้ก่อนเติมนามสกุล

    if (originalFile.type === "image/jpeg") {
      thumb_name.value = baseName + ".jpg"
      mimeType.value = "image/jpeg"
    } else if (originalFile.type === "image/png") {
      thumb_name.value = baseName + ".png"
      mimeType.value = "image/png"
    } else {
      // ในกรณีทีผู้ใช้เลือกไฟล์นามสกุลอืน ให้ใช้ชื่อเดิมหรือใช้นามสกุลเดิมของไฟล์นั้น
      thumb_name.value = baseName + "_" + originalFile.name
      mimeType.value = originalFile.type
    }

    // แก้ไขจุดนี้: สร้าง File Object ตัวใหม่เพื่อเปลี่ยนชื่อไฟล์ตามที่เราต้องการ
    const renamedFile = new File([originalFile], thumb_name.value, {
      type: originalFile.type,
      lastModified: originalFile.lastModified
    });

    // เก็บไฟล์ตัวใหม่ที่เปลี่ยนชื่อแล้วลงในตัวแปร (เพื่อเอาไปกดอัปโหลดทีหลัง)
    file_d.value = renamedFile; 

    // 3. สร้าง URL สำหรับแสดงภาพ Preview
    const previewUrl = URL.createObjectURL(renamedFile);
    if (uid.value !== '') {
      preview_e.value = previewUrl;
    } else {
      preview_a.value = previewUrl;
    }
    thumb.value = previewUrl;
  }
}


const addFile = uploadFetch;


async function addfileApi() {
  if (thumb_id.value) return true;
  // ใช้การสร้างตัวแปรปกติมารับค่าดิบ (หลีกเลี่ยงการส่ง .value เข้าโครงสร้าง Object ตรงๆ)
  const rawFile = file_d.value; 

  if (!rawFile || !rawFile.name) return false;

  const payload = {
    files: rawFile, // 🟢 ส่งตัวแปรดิบที่แกะค่า .value ออกมาแล้ว
    forGroupUid: listgroup.value[0].uid || "",
    forShopUid: "",
    publicAccess: true,
  };
  
  const response = await storedoc.uploadFetch(payload);
  if (response && response.status === 200 && response.data.rtnDesc === "success") {
        const resData = response.data.data;
        let uploadedUid = "";

          if (Array.isArray(resData) && resData.length > 0) {
            uploadedUid = resData[0]?.uid || resData;
          } else if (resData && typeof resData === 'object') {
            uploadedUid = resData.uid || resData;
          } else {
            uploadedUid = resData;
          }
          
    const cleanUid = String(uploadedUid).trim();
    thumb_id.value = cleanUid;
    return true; // 🟢 อัปโหลดสำเร็จ ส่งค่า true กลับไป
  } else {
    const errorMsg = response?.data?.rtnDesc || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์";
    swal("บันทึกไฟล์ไม่สำเร็จ", errorMsg, "error");
    return false; // 🔴 อัปโหลดไม่สำเร็จ ส่งค่า false กลับไป
  }
}

async function getFileLoco() {
  file_L.value = [];
  
  // 1. กรองเอาเฉพาะข้อมูลแถวที่มีการผูกโลโก้จริง (logoUid ไม่เป็น "0")
  const validItems = lb.value.filter(item => item.logoUid && item.logoUid !== "0");

  if (validItems.length > 0) {
    // 🟢 2. เปลี่ยนการสร้าง Requests มาส่งแบบ POST Payload ผ่าน Store ส่วนกลาง
    const requests = validItems.map((item) => {
      const filePayload = {
        groupUid: "", // ใส่ Uid กลุ่มของหน้านี้ (ถ้ามี) หรือส่งเป็นค่าว่างตามกฎ API
        shopUid: "",  // ใส่ Uid ร้านค้าของหน้านี้ (ถ้ามี) หรือส่งเป็นค่าว่างตามกฎ API
        uid: String(item.logoUid) // ไอดีโลโก้ธนาคารแถวนั้นๆ
      };
      
      // เรียกใช้ผ่านฟังก์ชัน store ส่วนกลางที่เราแก้เป็น POST ไว้แล้ว (ตรวจสอบชื่อตัวแปร store ของหน้านี้ให้ตรงนะครับ)
      return storedoc.getFileFetch(filePayload); 
    });

    try {
      // 🟢 3. เปลี่ยนจาก axios.all มาใช้ Promise.all ควบคุมดึงไฟล์พร้อมกันตามมาตรฐาน
      const allResults = await Promise.all(requests);
      
      if (allResults) {
        file_L.value = allResults;
        
        for (let i = 0; i < file_L.value.length; i++) {
          if (file_L.value[i] && file_L.value[i].status === 200 && file_L.value[i].data !== null) {
            const rawData = file_L.value[i].data;
            const isBlob = rawData instanceof Blob || (rawData && rawData.size !== undefined);
            
            if (isBlob) {
              // 🟢 4. สแกนตรวจสอบเนื้อไฟล์ดิบ (เนื่องจากฝั่ง API เอา Base64 ออกไปหมดแล้ว)
              const textHead = await rawData.slice(0, 4).text();
              let cleanBlob;

              if (textHead === "%PDF") {
                cleanBlob = new Blob([rawData], { type: 'application/pdf' });
              } else if (textHead.startsWith("PK")) {
                cleanBlob = new Blob([rawData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              } else {
                // 🖼️ สลัดหัวคำสั่งดาวน์โหลดของรูปโลโก้ทิ้ง บังคับครอบหัวภาพใหม่ให้สะอาด 100% บนหน้าบ้าน
                cleanBlob = new Blob([rawData], { type: 'image/jpeg' });
              }

              const dataUrl = URL.createObjectURL(cleanBlob);
              
              // 🟢 5. หาแถวข้อมูลธนาคารเดิมที่สอดคล้องกัน แล้วเอาลิงก์รูปพรีวิวที่สะอาดแล้วเข้าไปสวม
              const matchedItem = validItems[i];
              
              // ใช้ฟังก์ชัน filterFile ตัวเดิมของหน้านี้ในการค้นหา Object แถวที่แมตช์กัน
              const lf = filterFile(matchedItem.logoUid, lb.value);
              
              if (lf && lf.length > 0) {
                lf[0].thumb = dataUrl;
                lf[0].file = cleanBlob;
                lf[0].data = dataUrl;
              }
            }
          }
        }
      }
    } catch (e) {
      console.error("Error in Promise.all getFileLoco:", e);
    }
  }
}



function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}


</script>

<style lang="scss" scoped></style>
